import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SharedBadge from 'components/SharedBadge';
import ProjectIcon from './ProjectIcon';
const ProjectStatus = ({ listedProject, onRefetch }) => (_jsxs(_Fragment, { children: [_jsx(ProjectIcon, { listedProject: listedProject }), listedProject.shareCount > 1
            ? _jsx(SharedBadge, { project: listedProject, type: "sup", onRefetch: onRefetch })
            : null] }));
export default ProjectStatus;
